module.exports = require("@swa-ui/dotcom/src/SearchAutocomplete/SearchAutocomplete.module.scss");